module.exports = __webpack_public_path__ + "img/batman_boat.799a00d8.png";